





























import { Component, Vue, Prop } from "vue-property-decorator";
import { Message } from "element-ui";
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["account"])
})
export default class UploadCharge extends Vue {
    @Prop({ type: String })
    period!: string;

    @Prop({ type: Boolean })
    isTax!: boolean;

    file: any = null;
    fileName: string = "";
    title: string = this.isTax ? "导入税务信息" : "导入收费数据"
    changeFile(e: any) {
        if (e.target.files[0]) {
            this.file = e.target.files[0];
        }
    }
    getFileName(el: any) {
        let filename = el.currentTarget.files[0].name;
        let postfixname = filename.substring(
            filename.length - 3,
            filename.length
        );
        let fileName: any = document.querySelector("#fileInput .fileName");
        fileName.innerHTML = filename;
        this.fileName = filename
    }
    fnUpload() {
        let bookName, bookCode, data, num;
        let upfile: any = document.querySelector("#upfile");
        data = new FormData();
        data.append("file", upfile.files[0]);
        data.append("fileName", this.fileName);
        this.submit(data);
    }
    submit(data: any) {
        if (this.isTax) {
            Vue.axios
                .post(`system/upload/tax/info`, data)
                .then(res => {
                });
        } else {
            Vue.axios
                .post(`system/upload/charge`, data)
                .then(res => {
                });
        }
    }
}
